<template>
	<div>
		<loading v-if="!loaded" />
		<div class="md-layout" v-if="loaded">
			<div class="md-layout-item md-small-size-100 md-size-40">
				<div class="md-layout-item md-small-size-100 md-size-100">
					<h3>បន្តសុពលភាពអតិថិជន</h3>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-100 text-right">
					<span class="late">* តម្រូវឱ្យបំពេញ</span>
				</div>
				<div class="md-layout">
					<div class="md-layout-item md-small-size-100 md-size-100">
						<label>កញ្ចប់សេវាកម្ម *</label>
						<v-select label="name" inputId="id" :clearable="false" :options="packageList"
							v-model="client.packageArray">
						</v-select>
					</div>

				</div>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-60">
				<div class="md-layout-item md-small-size-100 md-size-100">
					<h3>ព័ត៌មានសង្ខេប</h3>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-100">
					<md-table>
						<md-table-row>
							<md-table-cell style="width: 40%;">ឈ្មោះអតិថិជន</md-table-cell>
							<md-table-cell style="width: 5px">:</md-table-cell>
							<md-table-cell>
								<span v-if="String(client.name).length > 0"><b>{{client.name}}</b></span>
								<span v-else>មិនទាន់មាន</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>លេខទូរស័ព្ទអតិថិជន</md-table-cell>
							<md-table-cell>:</md-table-cell>
							<md-table-cell>
								<span v-if="String(client.phone).length > 0"><b>{{client.phone}}</b></span>
								<span v-else>មិនទាន់មាន</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>សុពលភាពបច្ចប្បន្ន</md-table-cell>
							<md-table-cell>:</md-table-cell>
							<md-table-cell><b>
								<span v-if="String(client.expiry_date).length > 0">
									<!-- {{config.timelify(client.expiry_date)}} -->
									<template v-if="config.timelify(client.expiry_date) != 'មិនមានសុពលភាព'">
										<span class="green">{{config.expirydate(client.expiry_date)}}</span>
										({{config.timelify(client.expiry_date)}})
									</template>
									<template v-if="config.timelify(client.expiry_date) == 'មិនមានសុពលភាព'">
										<span class="late">{{config.timelify(client.expiry_date)}}</span>
									</template>
								</span>
								<span v-else>មិនទាន់មាន</span>
							</b>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>កញ្ចប់សេវាកម្ម</md-table-cell>
							<md-table-cell>:</md-table-cell>
							<md-table-cell><b>
								<span v-if="String(client.package_id).length > 0">{{client.packageArray.name}}</span>
								<span v-else>មិនទាន់មាន</span>
							</b>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>សុពលភាពថ្មី</md-table-cell>
							<md-table-cell>:</md-table-cell>
							<md-table-cell><b>
								<span v-if="String(client.package_id).length > 0">
									<span class="green">{{config.expirydate(new_expiry)}}</span>
										({{config.timelify(new_expiry)}})
								</span>
								<span v-else>មិនទាន់មាន</span>
							</b>
							</md-table-cell>
						</md-table-row>
					</md-table>
				</div>
			</div>
			<div class="md-layout-item md-size-100 text-right">
				<md-button class="md-raised md-primary" @click="renewClient()">បន្តសុពលភាព</md-button>
			</div>
		</div>
	</div>

	<!-- <md-dialog-confirm :md-active.sync="deleteDialogActive" md-title="តើអ្នកពិតជាចង់លុបក្រុមហ៊ុននេះពិតមែនទេ ?"
			md-content="ព័ត៌មានក្រុមហ៊ុននឹងត្រូវបានលុបចេញពីបញ្ជីជារាងរហូត។" md-confirm-text="លុប" md-cancel-text="បោះបង់"
			@md-cancel="onCancel" @md-confirm="onDelete" /> -->
	</div>

</template>

<script>
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {
			this.getPackage();
			// this.getClient();
		},

		data() {
			return {
				loaded: false,
				client: {
					name: "",
					phone: "",
					card: "",
					expiry_date: "",
					package_id: "",
					packageArray: "",
				},
				packageList: []
			}
		},
		watch: {
			'client.packageArray': function (val) {
				if (String(this.client.packageArray).length > 5) {
					this.client.package_id = this.client.packageArray.id;
				} else {
					this.client.package_id = "";
				}
			}
		},
		computed: {
			new_expiry() {
				let current_date = new Date();
				let client_expiry_date = new Date(this.client.expiry_date*1000);
				let current_expiry_date = client_expiry_date.getTime() > current_date.getTime() ? client_expiry_date : current_date;

				// console.log(current_date.getTime());
				// console.log(client_expiry_date.getTime());
				let new_package_duration = this.client.packageArray.duration;
				var new_expiry_date = new_package_duration > 12 ? (new Date(current_expiry_date.setDate(current_expiry_date.getDate()+new_package_duration))) : (new Date(current_expiry_date.setMonth(current_expiry_date.getMonth()+new_package_duration)));
				return parseInt(new_expiry_date.getTime() / 1000);
			}
		},
		methods: {
			getClient() {
				this.$http.get(this.config.api + '/admin/client/get/' + this.$route.params.hash_id).then(data => {
					this.client.name = data.body.data.name
					this.client.phone = data.body.data.phone
					this.client.expiry_date = data.body.data.expiry_date
					this.loaded =true;
				})
			},
			getPackage() {
				this.$http.post(this.config.api + "/admin/package/search", {
					text: "",
					offset: 0
				}).then(data => {
					this.packageList = data.body.data;
					this.getClient();
				})
			},
			renewClient() {
				if (!this.checkValidation()) return false;
				this.$http.post(this.config.api + "/admin/client/renew", {
					hash: this.$route.params.hash_id,
					package_id: this.client.package_id
				}).then(data => {
					if (data.body.status == 'success') {
						this.tabName = 'first'
						this.$notification.notify({
							message: "បន្តសុពលភាពដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						});
						this.$router.push("/clients/detail/" + this.$route.params.hash_id);
					}
					// this.loadMoreCompanyButton = true

				})
			},
			checkValidation() {
				if (String(this.client.package_id).length > 0) {
					return true;
				} else {
					this.$notification.notify({
						message: "សូមបញ្ចូលព័ត៌មាន។",
						icon: 'info',
						type: 'warning'
					});
					return false;
				}
			},
			clearAll() {
				this.search.text = "";
				this.client = {
					name: "",
					phone: "",
					card: "",
					note: "",
					branch_id: "",
					package_id: "",
					packageArray: "",
					branchArray: ""
				}
			}
		}
	}
</script>
<style scoped>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Clients/Renew.vue